import React, { useEffect, useState } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import { Grid, withStyles } from '@material-ui/core';

import Dashboard from '../../../../layouts/Dashboard';
import ListLocations, { Location } from '../../../../components/Global/Location/List';
import CustomSortableTable, { SortableTableHeader, SortableTableRow } from '../../../../components/CustomSortableTable';
import CustomViewToggle, { ViewType } from '../../../../components/CustomViewToggle';

import { locationsInitQuery } from './queries';

import styles from './styles';
interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

const OrgListLocations = ({ classes, history }: Props): React.ReactElement => {
  const [locations, setLocations] = useState<Location[]>([]);
  const [viewType, setViewType] = useState<ViewType>(ViewType.TABLE);

  const { data: locationsInitData, loading } = useQuery(locationsInitQuery(), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && locationsInitData) {
      setLocations(locationsInitData.locations);
    }
    return () => {
      mounted = false;
    };
  }, [locationsInitData]);

  const handleCreate = () => {
    history.push(`/org/locations/create`);
  };

  const handleEdit = (id: string) => {
    history.push(`/org/locations/${id}/edit`);
  };

  const handleView = (id: string) => {
    history.push(`/org/locations/${id}/edit`);
  };

  const tableHeaders: SortableTableHeader[] = [
    { key: 'name', label: 'Name' },
  ];

  const tableRows: SortableTableRow[] = locations.map((loc) => ({
    key: loc.id,
    columns: [
      { key: 'name', label: loc.name },
    ],
    actions: [
      { label: 'View', onClick: () => handleView(loc.id) },
      { label: 'Edit', onClick: () => handleEdit(loc.id) },
    ],
  }));

  return (
    <Dashboard breadcrumbs={[{ label: 'Locations' }]}>
      <Grid container spacing={4} alignItems="stretch">
        <Grid item xs={12}>
          <CustomViewToggle value={viewType} handleChangeView={setViewType} />
        </Grid>
        {viewType === ViewType.TABLE && (
          <Grid item xs={12}>
            <CustomSortableTable
              title="Locations"
              counter={locations.length}
              headers={tableHeaders}
              rows={tableRows}
              loading={loading}
              searchable={['name']}
              actions={[{ key: 'create', label: 'Create', onClick: () => handleCreate() }]}
            />
          </Grid>
        )}
        {viewType === ViewType.GRID && (
          <Grid item xs={12}>
            <ListLocations locations={locations} handleCreate={handleCreate} handleEdit={handleEdit} handleView={handleView} />
          </Grid>
        )}
      </Grid>
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(OrgListLocations));
